import { Injectable, signal } from '@angular/core';

// Shared open/closed state for the sidebar. On phones (<= md) the sidebar is an
// off-canvas drawer toggled from the topbar hamburger; on wider screens it is
// always visible, so this state only matters for the mobile drawer.
@Injectable({ providedIn: 'root' })
export class SidebarService {
  readonly isOpen = signal(false);

  toggle(): void {
    this.isOpen.update((v) => !v);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
